import { Form } from 'react-router'

import LogoutSVG from '#app/assets/svg/logout'

export default function LogoutForm() {
	return (
		<Form method="post" action="/auth/logout">
			<button className="btn btn-ghost btn-primary btn-sm rounded-[3px]">
				<LogoutSVG />
				Log Out
			</button>
		</Form>
	)
}
